import { RentalManagerBrowserEnvironment } from '@zg-rentals/rental-manager-env-base';

export { useCreateProperty } from './useCreateProperty';
export { useGetProperties } from './useGetProperties';
export { useMarkTermsAccepted } from './useMarkTermsAccepted';

export type { CreatePropertyRequest, CreatePropertyResponse } from './useCreateProperty';
export type { PropertyListing, GetPropertiesResponse } from './useGetProperties';

export const environment = process.env.NEXT_PUBLIC_LOCAL_BASE_URL
  ? process.env.NEXT_PUBLIC_LOCAL_BASE_URL
  : `${typeof window !== 'undefined' ? window.location.origin : ''}/`;

// TODO - Once tenant screening services API is migrated to proxit this will not be needed
// @ts-ignore
RentalManagerBrowserEnvironment.setInstance({
  brand: 'zillow',
  zgApi: environment,
  isClient: true,
  isServer: false,
});
